import { PrivacyPolicy } from "@/components/legal/PrivacyPolicy";

export const PrivacyPolicyPage = () => {
  return <PrivacyPolicy />;
};
